import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of Taekwondo drills.', 'This is not a generic martial arts manual filled with theory you still need to turn into a real class.', 'This is not an app or a video course.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-navy relative overflow-hidden" data-id="element-193" data-mp="1mt1uw4l1iv2q">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gold/60" data-id="element-194" data-mp="z1wiy0i80mxp" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-195" data-mp="u3uokjfch16x">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-196" data-mp="181t3pr1hp1nh">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/10 text-gold mb-5" data-id="element-197" data-mp="2jgg9rxb1qjyn">
            <span className="text-2xl" data-id="element-198" data-mp="2feuuk5b1htla">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-199" data-mp="2bw8jt81phr0z">
            The complete Taekwondo coaching system for instructors worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold mb-3" data-id="element-200" data-mp="2kwdsrmmjsxh9">TAEKWONDO INSTRUCTOR READY</h3>
          <p className="text-base md:text-lg text-white/80 mb-10" data-id="element-201" data-mp="2kukkk2wae575">
            7 Complete Volumes • 150 Ready-to-Teach Sessions • 5 Professional Bonus Guides
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-202" data-mp="1t34prlkktc5u">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-203" data-mp="1x7m6fbvn39ce">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-204" data-mp="1eg1sng0615j1">
                <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-205" data-mp="1ee8l7yhqah9z" />
                <p className="text-white/70 text-sm" data-id="element-206" data-mp="2hpxokyhxjyr9">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-cream-card p-6 rounded-2xl border border-gold" data-id="element-207" data-mp="2cq1kz0d5a9c8">
            <div className="flex items-start gap-3" data-id="element-208" data-mp="1yu7o5fpnbafh">
              <Check className="text-emerald-brand shrink-0 mt-1" size={20} data-id="element-209" data-mp="1tubi7axe18xa" />
              <p className="text-navy font-medium text-base leading-relaxed" data-id="element-210" data-mp="27tknvgnywkn0">
                Taekwondo Instructor Ready is a complete PDF-based professional coaching system
                created to help instructors plan less, teach with more structure and develop
                students from beginner to advanced.
              </p>
            </div>
            <p className="text-navy-medium font-bold text-sm mt-4 pl-8" data-id="element-211" data-mp="3eb7rrn3spkcc">
              Open the system. Choose the objective. Select the session. Teach.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}